export const DEFAULT_POLLING_TIME = 15000 // 15 seconds
export const BILL_REQUESTS_POLLING_TIME = 30000 // 30 seconds
export const DEFAULT_PAGINATION_SIZE = 10
export const DEFAULT_PAGINATION_OPTIONS = [
  { value: 10, title: "10" },
  { value: 25, title: "25" },
  { value: 50, title: "50" },
  { value: 100, title: "100" },
  { value: -1, title: "$vuetify.dataFooter.itemsPerPageAll" },
]
export const DEFAULT_QUERY_STALE_TIME = 1 * 60 * 1000
export const NEWSFEED_BLOCK_MAX_HEIGHT = 450
export const DAYS_YEAR = 365

export const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
] as const

export type WeekDay = (typeof weekDays)[number]

export const weekDaysShortNames: Record<WeekDay, string> = {
  monday: "Mon",
  tuesday: "Tue",
  wednesday: "Wed",
  thursday: "Thu",
  friday: "Fri",
}
